<template>
  <div>
    <el-dialog :title="title" :visible.sync="sendSmsVisible" :close-on-click-modal="false" :before-close="sendCancel" center width="520px">
      <el-form :inline="true"  :model="msgForm" ref="msgForm"  class="demo-form-inline jiaoyan" label-width="180px" size="mini">
        <div class="inpBox">
          <div style="width:100%;margin: 20px 0;" v-if="msgForm.successFlag == '0'">
            <div style="text-align: center;">密码与初始密码不一致，请重置密码后再发送短信</div>
          </div>
          <div style="margin: 28px 0;" v-if="msgForm.successFlag == '1'">
            <el-form-item label="企业名称:" prop="tenantName"  style="width:490px">
              <span>{{msgForm.tenantName}}</span>
            </el-form-item>
            <el-form-item label="访问地址:" prop="address"  style="width:490px">
              <span>{{msgForm.address}}</span>
            </el-form-item>
            <el-form-item label="用户姓名:" prop="userName"  style="width:360px">
              <span>{{msgForm.userName}}</span>
            </el-form-item>
            <el-form-item label="登录账号:" prop="userAccount"  style="width:360px">
              <span>{{msgForm.userAccount}}</span>
            </el-form-item>
            <el-form-item label="登录密码:" prop="password"  style="width:360px">
              <span>{{msgForm.password}}</span>
            </el-form-item>
            <el-form-item label="以上信息是否短信告知:" prop="isSend"  style="width:360px">
              <el-radio v-model="msgForm.isSend" label="0">是</el-radio>
              <el-radio v-model="msgForm.isSend" label="1">否</el-radio>
            </el-form-item>
            <el-form-item label="手机号:" prop="mobile" v-if="msgForm.isSend == 0"  style="width:360px">
               <el-input  placeholder=""  v-number-input.float="0"    maxlength="11"   v-model.trim="msgForm.mobile"></el-input>
            </el-form-item>
          </div>

        </div>
      </el-form>
      <div slot="footer">
        <el-button type="" @click="sendCancel">取消</el-button>
        <el-button type="primary" @click="sendSubmit" :loading='sendLoading'>确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getOriginPassUser,
  sendMessage
} from '@/api/newCrm.js'
export default {
  components: {
  },
  name: 'sendSmsDialog',
  data () {
    return {
      msgForm: {
        isSend: '1'
      },
      sendLoading: false,
      isShow: true
    }
  },
  props: {
    title: {
      type: String,
      default: '提示'
    },
    sendSmsVisible: {
      type: Boolean,
      default: false
    },
    userId: {
      type: Number
    }
  },
  watch: {
  },
  created () {
    this.getOriginPassUser()
  },
  mounted () {
  },
  methods: {
    getOriginPassUser () {
      getOriginPassUser({
        id: this.userId
      }).then(res => {
        this.msgForm = res
        this.$set(this.msgForm, 'isSend', '1')
        console.log(res.successFlag, '1111')
      }).catch(error => {
        this.$message({
          message: error.message,
          type: 'error'
        })
      })
    },
    sendSubmit () {
      if (this.msgForm.isSend == 0) {
        if (this.msgForm.successFlag == '1') {
          this.sendLoading = true
          sendMessage(this.msgForm).then(res => {
            this.sendLoading = false
            this.$message({
              message: '发送成功',
              type: 'success'
            })
            this.sendCancel()
          // this.getList(this.searchFrom)
          }).catch(error => {
            this.sendLoading = false
            this.$message({
              message: error.message,
              type: 'error'
            })
          })
        } else {
          this.sendCancel()
        }
      } else {
        this.sendCancel()
      }
    },
    sendCancel () {
      this.$emit('update:sendSmsVisible', false)
      // this.$parent.xztableData = []
      // this.$parent.xiugaiObj = {}
    }
  }
}

</script>

<style scoped lang='less'>
</style>
